<template>
    <div class="comment-page">
        <!-- 顶部迷你命盘运盘部分吸顶效果 -->
        <div class="comment-fate-topbar">
            <!-- 1、顶部菜单栏 -->
            <div v-if="!fromEmbedded || (fromEmbedded && !hideTitle)" class="comment-title-bar dsp-flex">
                <div class="comment-title-side">
                    <span v-if="fromEmbedded && !fromOtherComment" class="comment-title-back" @click="clickClose">
                        <i class="iconfont icon-guanbi"></i>
                    </span>
                    <span v-else class="comment-title-back" @click="clickBack">
                        <i class="iconfont icon-xiangzuo"></i>
                    </span>
                </div>
                <div class="comment-title-mid" @click="toggleName">
                    <span v-if="hideName">匿名</span>
                    <span v-else>{{detailInfo.f_name}}</span>
                </div>
                <div class="comment-title-side" v-if="fromShare && shareData.type != 0 && shareData.cansave == 1 && !otherSaved && !fromMyComment && !fromOtherComment" @click="clickSave">
                    <span class="comment-title-save">保存</span>
                </div>
                <div class="comment-title-side" v-if="fromMyComment || fromOtherComment">
                    <span v-if="fromEmbedded" @click="clickShare" class="comment-title-share">分享</span>
                    <span v-if="fromMyComment" class="comment-title-edit" @click="toggleMode">{{editValue}}</span>
                </div>
            </div>
            <!-- 2、小的:命盘+运盘组件 -->
            <mini-fate-fortune-panel 
                v-bind:fromPage="pageName"
                v-bind:fortuneItemFunc="changeFateSideListData"
                v-bind:fateSideCloseFunc="changeFateSideListData">
            </mini-fate-fortune-panel>
        </div>

        <template v-if="fromEmbedded">
            <comment-embedded-form v-if="canBeEdited"></comment-embedded-form>
            <comment-embedded-form-read v-else></comment-embedded-form-read>
        </template>
        <template v-else>
            <!-- 3.1、批盘编辑模块 -->
            <comment-form v-if="canBeEdited"></comment-form>
            <!-- 3.2、批盘阅读模块 -->
            <comment-form-read v-else></comment-form-read>
        </template>

        <!-- 4、底部菜单栏 -->
        <!--  && !fromEmbedded -->
        <comment-bottom-bar v-if="fromMyComment && showBottomBar"></comment-bottom-bar>

        <!-- 5、选择框:命局,强弱,用药 -->
        <vant-change-popup
            v-bind:showChange="showChange"
            v-bind:itemFunc="clickChangeItem"
            v-bind:changeList="curChangeList"
            v-bind:bottomBtnText="'自定义'"
            v-bind:overlayFunc="clickChangeOverLay"
            v-bind:bottomBtnFunc='clickChangeBottomBtn'>
        </vant-change-popup>

        <!-- 6、自定义弹框 -->
        <van-dialog v-if="curChangeType != ''" v-model="showCustom" v-bind:title="customData[curChangeType].title" confirmButtonText='确定' v-bind:before-close="beforeClose" show-cancel-button closeOnClickOverlay>
            <div class="create-group-input">
                <input type="text" v-model="inputCustom" v-bind:placeholder="customData[curChangeType].placeholder" maxlength="8" autofocus >
            </div>
        </van-dialog>

        <!-- 子页面 -->
        <router-view></router-view>
    </div>
</template>
<script>
import MiniFateFortunePanel from '../../layouts/panel/MiniFateFortunePanel.vue'
import CommentForm from '../../layouts/comment/CommentForm.vue'
import CommentEmbeddedForm from '../../layouts/comment/CommentEmbeddedForm.vue'
import CommentFormRead from '../../layouts/comment/CommentFormRead.vue'
import CommentEmbeddedFormRead from '../../layouts/comment/CommentEmbeddedFormRead.vue'
import CommentBottomBar from '../../layouts/comment/CommentBottomBar.vue'
import VantChangePopup from '../../layouts/vant/VantChangePopup.vue'
import { COMMENT_DOM } from '../../modules/dom'
import { SCHEME } from '../../modules/utils'
import { SHARE } from '../../modules/share'
import { DATA } from '../../modules/data'
export default {
    name: 'Comment',
    components: {MiniFateFortunePanel, CommentForm, CommentEmbeddedForm, CommentFormRead, CommentEmbeddedFormRead, CommentBottomBar, VantChangePopup},
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        hideTitle() {
            return this.$store.state.embedded.hideTitle;
        },
        showBottomBar() {
            return this.$store.state.comment.showBottomBar;
        },
        canBeEdited() {
            return this.$store.state.comment.canBeEdited;
        },
        otherSaved() {
            return this.$store.state.comment.otherSaved;
        },
        fromMyComment() {
            return this.$store.state.comment.fromMyComment;
        },
        fromOtherComment() {
            return this.$store.state.comment.fromOtherComment;
        },
        hideName() {
            return this.$store.state.comment.hideName;
        },
        detailInfo() {
            return this.$store.state.comment.detailInfo;
        },
        showChange() {
            return this.$store.state.comment.showChange;
        },
        curChangeType() {
            return this.$store.state.comment.curChangeType;
        },
        curChangeList() {
            return this.$store.state.comment.curChangeList;
        },
        fromShare() {
            return this.$store.state.othershare.fromShare;
        },
        shareData() {
            return this.$store.state.othershare.shareData;
        }
    },
    data() {
        return {
            pageName: 'Comment',
            showCustom: false,
            inputCustom: '',
            editValue: '浏览模式',
            customData: {
                'situation': {title: '自定义命局类型', placeholder: '请输入自定义命局的类型名'},
                'strong': {title: '自定义命局强弱', placeholder: '请输入自定义命局的强弱名'},
                'medicine': {title: '自定义病药用神类型', placeholder: '请输入自定义病药用神的类型名'},
            }
        }
    },
    mounted: function(){
        var path = this.$router.history.current.path;
        var params = this.$router.history.current.params;
        console.log('Comment mounted------', path, params)
        // 从命盘详情过来的时候,没数据就返回列表页
        if(params && params.from) {
            if(params.from == "detail" || params.from == 'othercomment') {
                if(!this.detailInfo || !this.detailInfo.id) {
                    this.$router.replace('/record');
                }
            }
        }
        if(path.indexOf('share') > -1) {
            setTimeout(() => {
                SHARE.initConfigShare();
            }, 3000);
        }
        if(this.fromEmbedded) {
            setTimeout(() => {
                this.initEmbeddedFunc();
                this.initCommentScrollFunc();
            }, 500);
        }else {
            this.initCommentScrollFunc();
        }
        this.$bus.on('updateCommentScrollFunc', this.initCommentScrollFunc);
    },
    destroyed() {
        this.$bus.off('updateCommentScrollFunc', this.initCommentScrollFunc);
    },
    methods: {
        initEmbeddedFunc() {
            var me = this;
            window.appFunc = {};
            window.appFunc.commentCallShare = function() {
                console.log('commentCallShare------')
                me.clickShare();
            }
            window.appFunc.commentCallToggleEdit = function(data) {
                console.log('commentCallToggleEdit------', data, data.edited)
                me.$store.state.comment.canBeEdited = data.edited;
                setTimeout(() => {
                    COMMENT_DOM.updateCommentFormStyle();
                    COMMENT_DOM.bindCommentFormScrollEvent(data.edited);
                }, 10);
            }
        },
        initCommentScrollFunc() {
            var me = this,
                curPath = this.$router.history.current.path,
                time = curPath.indexOf('share') == -1 ? 300 : 1000, // 分享页加载得慢一些
                fromShareEdit = curPath.indexOf('share') == -1 ? false : true;
            setTimeout(() => {
                COMMENT_DOM.updateCommentFormStyle();
                if(fromShareEdit) {
                    COMMENT_DOM.bindCommentFormScrollEvent(fromShareEdit);
                }
                me.editValue = me.canBeEdited ? '浏览模式' : '进行编辑';
                if(!me.canBeEdited) {
                    COMMENT_DOM.bindCommentFormScrollEvent(!me.canBeEdited);
                }
            }, time);
        },
        clickClose() {
            SCHEME.closeWebView();
            this.$store.dispatch('embedded/resetData');
        },
        clickBack() {
            var me = this,
                curPath = this.$router.history.current.path,
                params = this.$router.history.current.params,
                shareSaveData = this.$store.state.othershare.shareSaveData,
                shareFormData = this.$store.state.othershare.shareFormData;
            // console.log('clickBack------', curPath, params, this.otherSaved, this.shareData, shareSaveData, shareFormData)
            
            // 从嵌入式页面过来的
            if(this.fromEmbedded){
                // 重置数据
                this.$store.dispatch("comment/resetData");
                this.$store.dispatch("minifatefortune/resetMiniData");
                // 跳转
                var fullPath = this.$router.history.current.fullPath;
                var newPath = fullPath.replace('comment', 'othercomment');
                this.$router.replace(newPath);
                this.$store.state.comment.curSubTab = 4;
                return;
            }
            
            // 从分享页面来的 && 未保存为自己的:返回到列表页
            if(curPath.indexOf('share/comment') > 0) {
                // 重置数据
                this.$store.dispatch("othershare/resetData");
                this.$store.dispatch("comment/resetData");
                this.$store.dispatch('detail/resetData');
                this.$store.dispatch("minifatefortune/resetMiniData");
                this.$router.replace('/record');
                return;
            }

            // 从分享页面来的 && 已保存为自己的:
            if(this.otherSaved && params['id']) {
                this.$store.state.comment.curSubTab = 4;
                this.$router.replace('/othercomment');
                this.$store.dispatch('othercomment/getOtherPiPanList', {
                    detailId: params['id']
                });
                setTimeout(() => {
                    SHARE.initConfigShare();
                }, 10);
                return;
            }

            // 其他的从八字数据来的 || 从他人排盘页来的
            // 重置数据:同他人批盘列表页Comment.vue
            // 如果从批盘页退出到排盘页，清空他人批盘列表数据
            var initDetail = this.$store.state.detail.initDetail;
            if(params && params.from && params.from == 'detail') {
                if(!initDetail) {
                    this.$store.dispatch("detail/initDetail", this.detailInfo);
                }
                this.$router.replace("/detail/record/" + this.detailInfo.id);
                this.$store.dispatch("comment/resetData");
                this.$store.dispatch("othercomment/resetData");
                this.$store.dispatch("minifatefortune/resetMiniData");
            }
            // 如果从他人批盘查看页返回，切换底部的tab值
            if(params && params.from && params.from == 'othercomment') {
                this.$store.dispatch("comment/resetData");
                this.$store.dispatch("minifatefortune/resetMiniData");
                this.$store.state.comment.curSubTab = 4;
                this.$router.replace('/othercomment');
            }

            setTimeout(() => {
                SHARE.initConfigShare();
            }, 100);
        },
        toggleName() {
            if(this.$store.state.othershare.fromShare && this.$store.state.othershare.shareData && this.$store.state.othershare.shareData.cansave == 1) {
                return;
            }
            this.$store.state.comment.hideName = !this.$store.state.comment.hideName;
            setTimeout(() => {
                SHARE.initConfigShare();
            }, 100);
        },
        clickSave() {
            var me = this;
            this.$store.dispatch('othershare/triggerSaveShare');
        },
        clickShare() {
            // console.error('clickShare-------')
            var pipanTitle, shareId,
                commentData = this.$store.state.comment,
                detailData = this.$store.state.detail,
                embeddedData = this.$store.state.embedded;
            if(this.fromOtherComment) {
                pipanTitle = DATA.getOtherPipanShareTextByData('wechat', commentData.hideName, commentData.otherShareTitle, detailData.personInfo);
                shareId = this.hideName ? commentData.otherShareCode.nmothershare : commentData.otherShareCode.smothershare;
            }else {
                pipanTitle = DATA.getPipanSharedTextByData('wechat', commentData.hideName, {info: {nickname: embeddedData.nickName}}, detailData.personInfo);
                shareId = this.hideName ? commentData.shareCode.nmpishare : commentData.shareCode.smpishare;
            }
            SCHEME.configPiPanShare(pipanTitle, shareId);
        },
        clickChangeItem(data) {
            this.$store.state.comment.showChange = false;
            var params = {};
            switch(data.type) {
                case 'situation':
                    params = {info: { situation: data.id }, text: data.text};
                    this.$store.dispatch('comment/updatePiPan', params);
                    break;
                case 'strong':
                    params = {info: { strong: data.id }, text: data.text};
                    this.$store.dispatch('comment/updatePiPan', params);
                    break;
                case 'medicine':
                    params = {medicineItem: data};
                    this.$store.dispatch('comment/updatePiPanMedicine', params);
                    break;
                default:
                    break;
            }
        },
        clickChangeOverLay() {
            this.$store.state.comment.showChange = false;
        },
        clickChangeBottomBtn() {
            this.$store.state.comment.showChange = false;
            this.showCustom = true;
        },
        beforeClose(action, done) {
            if (action === 'confirm') {
                if(this.inputCustom != ''){
                    this.submitCustom(this.inputCustom);
                    done();
                }else {
                    this.$toast("名称不能为空");
                    done();
                }
            } else {
                done();
            }
            // 重置输入框数据
            var me = this;
            setTimeout(() => {
                me.inputCustom = '';
            }, 100);
        },
        submitCustom(text) {
            var me = this, params = {}, type = this.$store.state.comment.curChangeType;
            switch(type){
                case 'situation':
                    this.$store.dispatch('base/addSituation', {
                        text: text,
                        cb: function(data) {
                            params = {info: { situation: data.id }, text: data.text};
                            me.$store.dispatch('comment/updatePiPan', params);
                        }
                    });
                    break;
                case 'strong':
                    this.$store.dispatch('base/addStrong', {
                        text: text,
                        cb: function(data) {
                            params = {info: { strong: data.id }, text: data.text};
                            me.$store.dispatch('comment/updatePiPan', params);
                        }
                    });
                    break;
                case 'medicine':
                    this.$store.dispatch('base/addMedicine', {
                        text: text,
                        cb: function(data) {
                            console.log('addMedicine', data)
                            params = {medicineItem: data};
                            me.$store.dispatch('comment/updatePiPanMedicine', params);
                        }
                    });
                    break;
                default:
                    break;
            }
        },
        // 迷你命盘运盘的数据与大运流年数据的联动
        changeFateSideListData(data, fateSideListData) {
            var me = this;
            if(fateSideListData.length == 0) {
                setTimeout(() => {
                    me.updateCommentForm('');
                }, 300);
            }
            if(data.type == 'dayun' || data.type == 'liunian') {
                this.$store.dispatch('comment/updateCommentActiveNames', {
                    listData: fateSideListData,
                    cb: function(curName) {
                        me.updateCommentForm(curName);
                    }
                });
            }
        },
        updateCommentForm(curName) {
            if(this.canBeEdited) {
                COMMENT_DOM.updateCommentFormScrollTop(curName, this.$store.state.comment.curActiveName);
            }else {
                COMMENT_DOM.updateCommentFormReadScrollTop(curName);
            }
            this.$store.state.comment.curActiveName = curName;
        },
        toggleMode() {
            // this.$toast('前往最新版本APP操作更新批盘')
            var canBeEdited = this.$store.state.comment.canBeEdited;
            this.editValue = !canBeEdited ? '浏览模式' : '进行编辑';
            this.$store.state.comment.canBeEdited = !canBeEdited;
            setTimeout(() => {
                COMMENT_DOM.updateCommentFormStyle();
                COMMENT_DOM.bindCommentFormScrollEvent(canBeEdited);
            }, 0);
        }
    }
}
</script>